import axios from 'axios';
import {APIURL} from '../constants';

export const Authorization = {
	isAdmin : function(success, error)
	{
		axios.get(APIURL + 'user')
		.then((res) => {
			if(res.data.role === 'admin')
			{
				success(true)
			} else {
				success(false)
			}
		})
		.catch((err) => {
			console.log("Authorization/index", err);
			error(err);
		})
	}

}